import React from 'react'
import {
  SeeAllContainer,
  BasicCard,
  getTrimmedExcerpt,
  Tag
} from '@islandsstofa/react'
import useGetEvents from '@src/hooks/useGetEvents'
import { Event } from '@root/src/utils/resolvers'
import { Link } from 'gatsby'

const Results = ({ cards = [], title }: { cards: Event[]; title: string }) => {
  if (cards.length === 0) return null
  return (
    <div className='see-all__results'>
      <h3>{title}</h3>
      <div className='card-grid'>
        {cards.map((card, key) => (
          <Link key={key} to={card.url ?? '/'}>
            <BasicCard
              onRenderImage={() => (
                <img
                  className='image-rounded'
                  src={card.image.url}
                  alt={card.image.alt}
                />
              )}
              variant='extra-tall'
              onRenderFootnote={() => (
                <div>
                  {card.customTags.slice(0, 4).map((tag, idx) => {
                    return (
                      <Tag type={idx === 0 ? 'transparent' : 'basic'}>
                        {tag}
                      </Tag>
                    )
                  })}
                </div>
              )}
            >
              <h5>{card.name.text}</h5>
              <div
                dangerouslySetInnerHTML={{
                  __html: getTrimmedExcerpt('p', card.excerpt)?.html ?? ''
                }}
              />
            </BasicCard>
          </Link>
        ))}
      </div>
    </div>
  )
}

export default () => {
  const cards = useGetEvents()
  const events = cards.filter(
    card => card.date.getTime() >= new Date().setHours(0, 0, 0, 0)
  )
  const pastEvents = cards
    .filter(card => card.date.getTime() < new Date().setHours(0, 0, 0, 0))
    .slice(0, 3)

  return (
    <SeeAllContainer>
      <Results title='' cards={events} />
      <Results title='Liðnir viðburðir' cards={pastEvents} />
    </SeeAllContainer>
  )
}
